// extracted by mini-css-extract-plugin
export default {"container":"JobReview_container__evqln","title":"JobReview_title__aoJdU","body":"JobReview_body__nl1gE"};